import * as ACTIONS from "../actions";

var CryptoJS = require("crypto-js");

import Api from "../../services";
//import LoginModule from "./LoginModule";

const ResetModule = {
  state: {
    RESETLOADING: false,
    RESETERRORMESSAGE: null,
    USERID: null,
  },
  getters: {
    GETRESETLOADING: (state) => state.RESETLOADING,
    GETRESETERRORMESSAGE: (state) => state.RESETERRORMESSAGE,
    GETRESETPASSWORDUSERID: (state) => state.USERID,
  },
  actions: {
    [ACTIONS.CHECK_LINK_AVAILABLE]: (context, query) => {
      context.commit(ACTIONS.CHECK_LINK_AVAILABLE_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("authenticate/resetpasswordlinkvalidity" + query, {
          //headers: {
          //   token: context.rootState.LoginModule.token
          //}
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.CHECK_LINK_AVAILABLE_SUCCESS,
              ACTIONS.CHECK_LINK_AVAILABLE_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.CHECK_LINK_AVAILABLE_ERROR);
            return reject(err);
          });
      });
    },

    [ACTIONS.CHANGE_PASSWORD]: (context, query) => {
      let token = query.get("Token");
      query.delete("Token");
      context.commit(ACTIONS.CHANGE_PASSWORD_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("authenticate/ChangePassword", query, {
          headers: {
            TOKEN: token,
          },
        })
          .then((res) => {
            debugger;
            commit.success(
              context,
              res,
              ACTIONS.CHANGE_PASSWORD_SUCCESS,
              ACTIONS.CHANGE_PASSWORD_ERROR,
              false,
            );
            var { data } = res;
            if (data && data.StatusCode == 200) {
              var role = DecryptRoleAndDepartment.Decrypt(
                data.ResponseData.RoleId,
              );
              role = role == null || role == "" ? 0 : parseInt(role);
              data.ResponseData.RoleId = role;
              if (role == 4) {
                var depts = DecryptRoleAndDepartment.Decrypt(
                  data.ResponseData.deptId,
                );

                if (depts != null || depts != "") {
                  data.ResponseData.deptId = depts;
                } else {
                  data.ResponseData.deptId = "-1";
                }
              } else {
                data.ResponseData.deptId = "0";
              }
              HandleCookie.SetCookie(data);
            }
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.CHANGE_PASSWORD_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.RESET_PASSWORD]: (context, query) => {
      let token = query.get("Token");

      context.commit(ACTIONS.RESET_PASSWORD_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("authenticate/resetpasswordforuser", query, {
          headers: {
            TOKEN: token,
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.RESET_PASSWORD_SUCCESS,
              ACTIONS.RESET_PASSWORD_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.RESET_PASSWORD_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.DUPLICATE_EMAIL_RESET_PASSWORD]: (context, data) => {
      return new Promise((resolve, reject) => {
        let url = "Authenticate/CheckDuplicateEmail";
        var params = new URLSearchParams();
        params.append("value", data.value);
        params.append("otherData[0].key", "id");
        params.append("otherData[0].value", data.id == null ? 0 : data.id);
        Api.post(
          url,
          params, //, {
          // headers: {
          //     token: context.rootState.LoginModule.token
          // }
          //}
        )
          .then((res) => {
            var { data } = res;
            if (data) {
              return resolve({
                data: data.isValid,
              });
            } else {
              return resolve({
                data: true,
              });
            }
          })
          .catch((err) => {
            return reject({
              data: true,
            });
          });
      });
    },
  },
  mutations: {
    [ACTIONS.CHECK_LINK_AVAILABLE_PENDING]: (state) => {
      state.RESETLOADING = true;
      state.RESETERRORMESSAGE = null;
    },
    [ACTIONS.CHECK_LINK_AVAILABLE_SUCCESS]: (state, data) => {
      state.RESETLOADING = false;
      state.RESETERRORMESSAGE = null;
      state.USERID = data.UserId;
    },
    [ACTIONS.CHECK_LINK_AVAILABLE_ERROR]: (state, msg) => {
      state.RESETLOADING = false;
      state.RESETERRORMESSAGE = msg;
    },
    [ACTIONS.RESET_PASSWORD_PENDING]: (state) => {
      state.RESETLOADING = true;
      state.RESETERRORMESSAGE = null;
    },
    [ACTIONS.RESET_PASSWORD_SUCCESS]: (state) => {
      state.RESETLOADING = false;
      state.RESETERRORMESSAGE = null;
    },
    [ACTIONS.RESET_PASSWORD_ERROR]: (state, msg) => {
      state.RESETLOADING = false;
      state.RESETERRORMESSAGE = msg;
    },
    [ACTIONS.CHANGE_PASSWORD_PENDING]: (state) => {
      state.RESETLOADING = true;
      state.RESETERRORMESSAGE = null;
    },
    [ACTIONS.CHANGE_PASSWORD_SUCCESS]: (state) => {
      state.RESETLOADING = false;
      state.RESETERRORMESSAGE = null;
    },
    [ACTIONS.CHANGE_PASSWORD_ERROR]: (state, msg) => {
      state.RESETLOADING = false;
      state.RESETERRORMESSAGE = msg;
    },
  },
};

export default ResetModule;

const key = CryptoJS.enc.Utf8.parse("7061737323313233");
const iv = CryptoJS.enc.Utf8.parse("7061737323313233");
const DecryptRoleAndDepartment = {
  Encrypt: function(string) {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(string), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted;
  },
  Decrypt: function(string) {
    var decrypted = CryptoJS.AES.decrypt(string, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      } else {
        commit(SuccessAction);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};

const HandleCookie = {
  SetCookie: function(data) {
    var key = "",
      possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var length = Math.floor(Math.random() * 100) + 60;
    for (var i = 0; i < length; i++) {
      key += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    var accessToken = CryptoJS.AES.encrypt(data.ResponseData.token, key);
    var name = CryptoJS.AES.encrypt(data.ResponseData.name, key);
    var RoleId = CryptoJS.AES.encrypt("" + data.ResponseData.RoleId, key);
    var UserId = CryptoJS.AES.encrypt("" + data.ResponseData.user, key);
    var deptId = CryptoJS.AES.encrypt("" + data.ResponseData.deptId, key);

    var d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000); // two hrs
    var expires = "expires=" + d.toGMTString();
    var s = process.env.NODE_ENV == "development" ? "" : "secure;";
    //1
    // if (Boolean(UAT) || Boolean(LIVE)) {
    //   s = "secure;";
    // }
    document.cookie =
      "univ_id=" +
      key +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "uid=" +
      accessToken +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "un=" +
      name +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    //document.cookie = "u_bid=" + Bank + ";" + expires + ";path=/";
    document.cookie =
      "r0_id=" +
      RoleId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "_C_VD=" +
      UserId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
    document.cookie =
      "_CVX_WR=" +
      deptId +
      ";" +
      expires +
      ";path=/" +
      ";samesite=strict;" +
      (s == "" ? "" : s);
  },
};
